import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $.datetimepicker.setLocale("pt-BR");
    $(this.element).datetimepicker({
      mask: true,
      format: "d/m/Y H:i",
      step: 15
    });
  }
}
